export const getFilenameFromUrl = (url?: string): string => {
    return url?.split('/')?.[3] ?? '';
};
